export default "__VITE_ASSET__BJBDC2Bo__"